import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import Styles from "../styles.module.scss";
import AuthHead from "../AuthHead";
import AuthMedia from '../authMedia';
import Button from '../../../components/button';
import Headline4 from '../../../components/headings/Headline4';
import GIcon from '../../../assets/images/g-icon.svg';
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { LoginForm } from './loginForm';
import { useLocation } from 'react-router-dom';
import { CognitoHostedUIIdentityProvider  } from "@aws-amplify/auth/lib/types";
import NotificationAlert from '../../../components/notification';
import mixpanelData, { userProfile } from '../../../utils/mixpanel'
import { getAPI, postAPI } from '../../../api/apis';
import { REACT_APP_CANDIDATE, REACT_APP_CANDIDATE_FREELANCER, REACT_APP_VERIFY } from '../../../utils/common';

Auth.configure({
  userPoolId: "ap-south-1_xW3Zsub3t",
  userPoolWebClientId: "2jn6qgntppsud848ri333cud5s", // app client id
  //identityPoolId: "42efbd0d-8bcb-46a2-b028-0a8affe3bb63",
  region: "ap-south-1",
  oauth: {
    region: "ap-south-1",
    domain: "authmyworkplace.ellow.io",
    scope: ["phone", "email", "openid", "aws.cognito.signin.user.admin", "profile"],
    redirectSignIn: "https://myworkplace.ellow.io/login?provider=google",
    redirectSignOut: "https://myworkplace.ellow.io/login",
    responseType: "code" // or 'token', note that REFRESH token will only be generated when the responseType is code
  }
})

function Login() {

  let navigate = useNavigate();
  const location = useLocation();
  let googleId :any ;
  const stateValues: any = location.state 
  const [error, setError] = useState<string>('')
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [disabled, setDisabled] = useState<boolean>(false)

// << url params are passed for verification purpose >>
  let value:any;
  let query: any = window.location.href
  let urlParams: any = new URL(query);
  let email: any = urlParams.searchParams.get('email') || (stateValues && stateValues.email) || null
  let code: any = urlParams.searchParams.get('confirmationCode')
  let provider: any = urlParams.searchParams.get('provider')
  
  let candidateJobId : any = urlParams.searchParams.get('candidateJobId')
  let loginId : any = urlParams.searchParams.get('loginId')
  let redirect : any = urlParams.searchParams.get('redirect')
  
  if(email){
    value = email.replace(/ /g, '+');
  }

  async function getCurrentUser() {

    try {
      var currentUser = await Auth.currentAuthenticatedUser()
      // setGoogleId(currentUser.username)
      googleId = currentUser.username
      return currentUser;
    }
    catch (err: any) {
      console.log('err', err)  
    }
  } 
  
   useEffect(() => {

    if (code) {      
      //  << api for chnaging the verification status of the user >>
      submitVerification(code)
    }
    
    if(provider === 'google'){
      displayUserDetails()  
    }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   },[]);

   async function displayUserDetails() { 

    getCurrentUser()
    Auth.userAttributes(await getCurrentUser())
    
    .then(async result => {
      
        let index = result.findIndex((item) => item.Name === 'email')
        localStorage.setItem('loginId', googleId)
        let values = {
          "loginId": googleId,
          "candidateStatus": '1',
          "provider": "google",
          "profileMetadata": {
            "firstName": result[3].Value,
            "lastName": result[4].Value,
            // "phoneNumber": '',
            "email": result[5].Value,
            "image": result[6].Value
          },
          sourcedBy: 'FREELANCER',
          submittedBy: 'FREELANCER',
          behalfOf: googleId
        }
        const session = await Auth.currentSession();
        const accessToken = session.getIdToken().getJwtToken();   
        // const refreshToken = session.getRefreshToken().getToken();
        localStorage.setItem('Token', accessToken)
        redirection(values, result[index].Value)   
       })
    .catch(err => console.log('err', err));
      }

    const redirection = (values: {candidateStatus?: string, loginId?: string, profileMetadata?: {firstName?: string, lastName?: string, email?: string, phonenumber?: string, image: string}, provider?: string}, email: string) => {
      getAPI( REACT_APP_CANDIDATE_FREELANCER + `/profile-completion-status?email=${email}`).then((response: any) => {
        if( response && response.data.length > 0){
          localStorage.setItem("profile_metadata", JSON.stringify(response.data[0].profilemetadata))
          localStorage.setItem("candidate_status", response.data[0].status)
          localStorage.setItem('candidateid', response.data[0].candidateid)
          if(response.data[0].status === 1)
          {          
            navigate(`/basic-details`,
            { state: {
              loginId:googleId
            }}
          ) 
          }
    
          if(response.data[0].status !== 1 && response.data[0].status !== 6  && response.data[0].status !== 7 ) {
            navigate(`/dashboard`, {
              state: {
                loginId: googleId
              }
            })
          }

          if (response.data[0].status === 6 || response.data[0].status === 7) {
            setError('Sorry we are unable to process this request now, Please contact our team at team@ellow.io')
          }
        }else{
          updateSignupDetails(values, email)
      
        }
      } )
    }

   async function updateSignupDetails(values: {candidateStatus?: string, loginId?: string, profileMetadata?: {firstName?: string, lastName?: string, email?: string, phonenumber?: string, image: string}, provider?: string}, email: string){   
    await postAPI ( REACT_APP_CANDIDATE + '/login-params', values).then((data) => {
      mixpanelData('MWP-Google SignIn', {
        'source': "freelancer login through Gmail",
        'success': true,
        'distinct_id': values.profileMetadata?.email,
        'Email': values.profileMetadata?.email
      })
      mixpanelData('New MWP - Google signup', {
        'source': "freelancer login through Gmail",
        'success': true,
        'distinct_id': values.profileMetadata?.email,
        'Email': values.profileMetadata?.email,
        'Signin via': 'email'
      })
      if (data && data.error) {
        return
      }
      localStorage.setItem('loginId', googleId)
      navigate(`/basic-details`,
      { state: {
        loginId: googleId
      }}
    ) 
    })
  }   



   const submitVerification = (code: string) => {

    let data = {
      candidateId: code
     }

    postAPI( REACT_APP_VERIFY + '/verifycandidate', data).then((response) => {
      if(response && response.status === 1){   
        mixpanelData('New MWP - Email verified', {
          'distinct_id': response.data[0].profile_metadata.email,
          'Email': response.data[0].profile_metadata.email,
          'Candidate loginid': response && response.data[0].login_id,
          'Email verified': true
        })
        setNotification(true);
        setMessage('')
        setTimeout(() => {
          setNotification(false)
        }, 4000);
        setMessage('Verification completed, please signIn with your registered Email Id');   
      }
    })

   }
   


  const submitValues = (data: any) => {
    setDisabled(true)
    let userData = {
      username: data.email,
      password: data.password
    }

    Auth.signIn(userData.username, userData.password)
      .then(async (result: any) => {
        const session = await Auth.currentSession();
        const accessToken = session.getIdToken().getJwtToken();   
        // const refreshToken = session.getRefreshToken().getToken();
        localStorage.setItem('Token', accessToken)
        localStorage.setItem('loginId',result.username)
        localStorage.setItem('Email', userData.username)
        getAPI( REACT_APP_CANDIDATE_FREELANCER + `/profile-completion-status?candidateId=${result.username}`).then((response: any) => {  
          if( response && response.status === 1){
            userProfile({
              '$email': userData.username,
              '$name': response.data[0].profilemetadata.firstName + ' ' + response.data[0].profilemetadata.lastName
            }, result.username)
          localStorage.setItem("profile_metadata", JSON.stringify(response.data[0].profilemetadata))
          localStorage.setItem("candidate_status", response.data[0].status)
          localStorage.setItem('candidateid', response.data[0].candidateid)
          localStorage.setItem('Name',response.data[0].profilemetadata.firstName + ' ' + response.data[0].profilemetadata.lastName)
          if(response.data[0].status === 1 )
          {            
            navigate(`/basic-details`, {
              state: {
                loginId: result.username
              }
            }) 
          }
          if(response.data[0].status !== 1 && response.data[0].emailverificationstatus === false){
            navigate(`/verification`, {
              state: {
                email: userData.username
              }
            })
          }
          if(response.data[0].status !== 1 && response.data[0].status !== 6  &&  response.data[0].status !== 7 && response.data[0].emailverificationstatus === true && redirect === null) {
            navigate(`/dashboard`, {
              state: {
                loginId: result.username
              }
            })
          }
          if(redirect ==='contractsignin'){ 
            if(loginId === result.username){
              navigate(`/contractsignin`, {
                state: {
                  loginId: loginId , candidateJobId: candidateJobId
                }
              }) 
            }
          }
          if (response.data[0].status !== 6 || response.data[0].status !== 7) {
          setError('Sorry we are unable to process this request now, Please contact our team at team@ellow.io')
          }
          }
        })

          // getAPI(`profilecompletionstatus?candidateId=${result.username}`, true).then(resp => {
          //   console.log(resp);
          // })
        let body: any = {
          username :data.email,
          distinct_id: data.email
        }
        let newmixpanelbody: any = {
          "Email" :data.email,
          "distinct_id": data.email,
          "Candidate loginid": localStorage.getItem('loginId')
        }
        mixpanelData('MWP-Login successfull', body)  
        mixpanelData('New MWP - Login', newmixpanelbody)  
      })
      .catch(err => {    
        mixpanelData('MWP-Login Failed', {
          'username' :data.email,
          'distinct_id': data.email,
          'Reason': err && err.message
        })
        mixpanelData('New MWP - Login failed', {
          'Email' :data.email,
          'distinct_id': data.email,
          'Failure reason': err && err.message
        })
        setDisabled(false)
        setError(err.message)
      });
  }

  const googleSignIn = () => {
    Auth.federatedSignIn({provider:  CognitoHostedUIIdentityProvider.Google})
    .then(result => {
      debugger;
      // displayObject(result);
    })
    .catch((err: any) => {
      // displayObject(err);
    });
  }
  const onClose = () =>{
    setNotification(false)
  }



  return (
    <section className="App">
      <div className={Styles.authWapper}>
        <div className={Styles.loginForm}>
          <AuthHead />
          <div className={Styles.alignCenter}>
          <aside className={Styles.loginSignupWapper}>
            

            <Headline4>Hey, Great to see you again !</Headline4>
            {  notification &&            
                <div>
                  <NotificationAlert closable={true} onClose={onClose} > { message } </NotificationAlert>
                </div>
              }
              <Button  onClick={googleSignIn} variant="socialprimary" size="medium"><img src={GIcon} alt="Gicon" />Sign in with Google</Button>
              <div className={Styles.or}>OR</div>


            <div className={Styles.loginWith}>

              {/* {clicked  ?

                // <div>
                //   <Button onClick={buttonClicked} variant="outlined" size="large">Sign in With Email</Button>
                // </div>
                // :
                <div> */}

                  <LoginForm emailValue={email ? value : ''} ClickHandler={submitValues} disabled={disabled}/>
                {/* </div>

              } */}
              {error&&<div><p className="error-message">{error}</p></div> }      
                <div className={Styles.alreadyRegistered}>Don’t have an Ellow account? <Link to="/signup">Sign up</Link></div>
           </div>
           
            </aside>
            {/* <div className={Styles.privacyPolicy}>
                  By creating an account, I agree to receive Arc communications via email, 
                  and agree with the ellow <Link to="/">Terms of Service</Link>, <Link to="/">Privacy Policy</Link>, and <Link to="/">Cookie Policy</Link>. 
                  I understand that I can unsubscribe at any time.
              </div> */}
              </div>
         </div>
        <AuthMedia/>
         </div>
     </section>
    );
 }


export default Login;
